exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-bullets-menu-2AWbT{display:flex;flex-flow:row wrap;border:none;box-shadow:none;background:none;-webkit-backdrop-filter:none;backdrop-filter:none}.style-bullets-menu-2AWbT>div{width:25%;height:80px}.style-bullets-menu-item-d06Vi{width:100%;height:100%;padding:0;margin:0;display:inline-flex;align-items:center;justify-content:center}.style-bullets-menu-item-d06Vi>div{padding:10px 20px}.style-bullets-menu-item-d06Vi.style-selected-8kksF{background-color:rgba(0,0,0,.08)}", ""]);

// Exports
exports.locals = {
	"bullets-menu": "style-bullets-menu-2AWbT",
	"bullets-menu-item": "style-bullets-menu-item-d06Vi",
	"selected": "style-selected-8kksF"
};